import {Order} from '../domain/Order';
import {Quote} from '../domain/types';
import {error} from '../utils/log';
import AuthService from './AuthService';
import TradingBlockRemote, {Filter} from './TradingBlockRemote';

// Elite Order service access vkarpel orders to show with filter
// Backend should login to normal sft account to have access to tb data.
// So server has 2 ways: access data with cache or load on times . We need to provide safety of account.

declare var ForeCore: any;
interface OrdersResponse { ResponseCode: number; Payload?: {Items: Order[], TotalCountOfItems: number}; }
export default class EliteOrdersService {
  public static  async loadOrders(portfolioID: number, filter: Filter): Promise<any> {
    return new Promise((resolve: (o: OrdersResponse['Payload']) => void, reject: (status: any) => void) => {      
      const filt = TradingBlockRemote.AddMandatoryFields(filter);
      
      const xhr = new XMLHttpRequest() as any;
      xhr.open('post',  '/api/portfolio/' + portfolioID + '/EliteOrders', true);
      xhr.withCredentials = true;

      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      // obj =  Object.assign(obj, controllers.getLoginCtrl().getAccountParams());

      xhr.onreadystatechange = function() {
        if (this.readyState !== 4) { return; }

        if (this.status !== 200) {          
          return reject(this.status);
        }

        return resolve(JSON.parse(this.response).d);
      };
      xhr.send(JSON.stringify(filt));
      return xhr;        
    });
  }

  // separate quote to allow user to be not logged to tradingblock
  public static async loadQuotes(portfolioID: number, symbols: string[]): Promise<any> {
    return new Promise((resolve: (o: OrdersResponse['Payload']) => void, reject: (status: any) => void) => {
      const xhr = new XMLHttpRequest() as any;
      xhr.open('post',  '/api/portfolio/' + portfolioID + '/GetEliteQuotes', true);      
      xhr.withCredentials = true;

      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      // obj =  Object.assign(obj, controllers.getLoginCtrl().getAccountParams());

      xhr.onreadystatechange = function() {
        if (this.readyState !== 4) {
          return;
        }

        if (this.status !== 200) {
          if (process.env.VUE_APP_DEBUG_LOG) {
            console.warn('bad status:' + this.status);
          }
          return reject(this.status);
        }

        return resolve(JSON.parse(this.response).d);
      };
      xhr.send(JSON.stringify(symbols));
      return xhr;

    });
  }
}
